import {useTheme} from 'quickstart/system'
import {Font, fontSpecs} from 'quickstart/theme/base/fonts'
import {FontName} from 'quickstart/theme/types'
import {GlobalStyle} from 'quickstart/theme/global'
import {Dict, truthy} from 'quickstart/types'
import {logger, magicSort} from 'tizra'
import * as B from '../block'
import {Admin, GlobalAdmin, defaultGlobalConfig, globalMigrate} from './admin'

const log = logger('quickstart/blocks/ThemeBlock')

const makeFontUrl = ({name, weights}: {name: string; weights: string[]}) => {
  const usp = new URLSearchParams({
    family: `${name}:wght@${weights.join(';')}`,
    display: 'swap',
  })
  return `https://fonts.googleapis.com/css2?${usp}`
}

const sortedUniqueValues = (x: Dict<any>): string[] => {
  const values = Object.values(x)
    .filter(truthy)
    .map(x => `${x}`)
  const unique = Array.from(new Set(values))
  return magicSort((x: string) => x)(unique)
}

type Theme = {
  baseFonts: {[k in Font]: FontName}
}

export const ThemeBlock = B.blockWithInfo(
  {
    name: 'theme',
    displayName: 'ThemeBlock',
    title: 'Theme', // required but not used
    Admin,
    GlobalAdmin,
    globalMigrate,
    defaultGlobalConfig,
    wrapperDiv: false,
  },
  () => {
    const theme = useTheme() as Theme
    const fontNames = sortedUniqueValues(theme.baseFonts) as FontName[]
    const urls = fontNames
      .filter(name => name in fontSpecs)
      .map(name => {
        const weights = sortedUniqueValues(fontSpecs[name].weights)
        return makeFontUrl({name, weights})
      })

    return (
      <>
        {urls.map((url, i) => (
          <link href={url} rel="stylesheet" key={i} />
        ))}
        <GlobalStyle />
      </>
    )
  },
)

export const useThemeConfig = () => B.useGlobalConfig(ThemeBlock)
